import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { PRODUCT_CAMPAIGN_NAMES } from "../../pages/focusItems/enums";

const normalTemplate = {
  loading: false,
  error: '',
  data: {},
  init: false
};

const initialState = {
  specialBrands: {
    loading: false,
    error: '',
    data: [],
    init: false
  }, focusedItems: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  bannerTypes: {
    loading: false,
    error: '',
    data: [],
    init: false
  },

  fItems: {
    loading: false,
    error: '',
    searchText: '',
    data: {}
  },
  initialData: {
    template: {
      loading: false,
      error: '',
      data: [],
      init: false
    }
  },
  predictionCampaigns: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  predictionCategories: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  categories: {},
  [PRODUCT_CAMPAIGN_NAMES.productCampaignDiscounted]: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  [PRODUCT_CAMPAIGN_NAMES.productCampaignNormal]: {
    loading: false,
    error: '',
    data: [],
    init: false
  }
};

const searchSlice = createSlice({
  name: 'search',
  initialState: initialState,
  reducers: {
    updateSpecialBrands: (state, action) => {
      state.specialBrands.error = action.payload.error;
      state.specialBrands.loading = false;
      if (action.payload.data) {
        state.specialBrands.init = true;
        state.specialBrands.data = action.payload.data;
      }

    },
    loadSpecialBrands() {
    },
    updateFocusedItems: (state, action) => {
      state.focusedItems.error = action.payload.error;
      state.focusedItems.loading = false;
      if (action.payload.data) {
        state.focusedItems.init = true;
        state.focusedItems.data = action.payload.data;

      }

    },
    setSearchResult: (state, action) => {
      const { error, data, type } = action.payload;
      if (error) {
        state[type].error = error;
      } else {
        state[type].data = data;
        state[type].init = true;
      }
      state[type].loading = false;
    },
    setInitialSearchData: (state, action) => {
      const { error, data, loading, id } = action.payload;

      if (loading !== undefined) {

        if (!state.initialData[id]) {
          state.initialData[id] = { ...state.initialData.template }
        }

        state.initialData[id].loading = loading

      } else if (error !== undefined) {
        state.initialData[id].error = error;
        state.initialData[id].loading = false
      } else {
        state.initialData[id].data = data;
        state.initialData[id].loading = false
        state.initialData[id].init = true
      }
    },
    loadFocusedItems() {
    },
    setLoading: (state, action) => {
      state[action.payload.type].error = '';
      state[action.payload.type].loading = action.payload.loading;
    },
    setSearchItems: (state, action) => {
      const { error, data, element, searchText, loading, type } = action.payload;
      if (loading !== undefined) {
        state[element].loading = loading;
      } else if (error !== undefined) {
        state[element].error = error;
        state[element].loading = false;
      } else {
        state[element].data[`${searchText}-${type}`] = data;
        state[element].loading = false;
      }

    },


    tryGetProductCampaign: () => {
    },
    tryLoadFocusItems: () => {
    },
    tryGetAllBannerTypes: () => {
    },
    tryLoadInitialSearchData: () => {
    },
    tryGetPredictionCampaign: () => {
    },
    tryGetPredictionCategories: () => {
    },
    reset: (state, action) => {
      state[action.payload.element] = initialState[action.payload.element];
    },

    resetAllSearch: (state, action) => cloneDeep(initialState)
  }
});


export const {
  updateSpecialBrands,
  loadSpecialBrands,
  setLoading,
  updateFocusedItems,
  loadFocusedItems,
  resetAllSearch,
  tryGetProductCampaign,
  tryGetAllBannerTypes,
  setSearchResult,
  reset,
  setSearchItems,
  tryLoadFocusItems,
  setInitialSearchData,
  tryLoadInitialSearchData,
  tryGetPredictionCampaign,
  tryGetPredictionCategories
} = searchSlice.actions;

export default searchSlice.reducer;
